import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import './CommunityPostUpdate.css';
import { apiGetSpecificCommunityPost, apiUpdateSpecificCommunityPost } from '../api/api';

const CommunityPostUpdate = () => {
  const navigate = useNavigate();
  const { id, postId } = useParams();
  const [post, setPost] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [status, setStatus] = useState();

  const init = async (id) => {
    const result = await apiGetSpecificCommunityPost(id);
    result.status === 200 && setPost(result.data.content);
    setTitle(result.data.content.title);
    setContent(result.data.content.content);
  }

  const handleSubmit = async e => {
    e.preventDefault();
    const data = post;
    data.title = title;
    data.content = content;
    data.isUpdated = true;
    data.updatedAt = new Date().toISOString();
    console.log(data);

    const result = await apiUpdateSpecificCommunityPost(postId, data);
    if (result.data.status === 'updated') {
      setStatus(
        <Alert severity="success">
          <AlertTitle>Success</AlertTitle>
          Successfully update your post — <strong>Congrats!</strong>
        </Alert>
      )
      setTimeout(() => {
        navigate(`/community/${id}/discussion`)
      }, 5000);
    } else {
      setStatus(
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          Something wrong with your input — <strong>Check again!</strong>
        </Alert>
      )
    }
  }

  useEffect(() => {
    init(postId);
  }, [postId]);

  return (
    <div className="updatePost">
      {status && <div style={{marginBottom: '1rem'}}>{status}</div>}
      <h1 id="post__title">Update Post</h1>
      <form onSubmit={handleSubmit}>
        <input 
          id='title__field'
          data-testid='title__field'
          type="text" 
          placeholder='Title'
          autoComplete='off'
          maxLength={50}
          value={title}
          onChange = {e => setTitle(e.target.value)}
          required 
        />
        <textarea 
          name="create-post" 
          id="post__field" 
          data-testid='post__field'
          rows="5" 
          autoComplete='off'
          maxLength={255}
          value={content}
          onChange = {e => setContent(e.target.value)}
          placeholder='Write a post...'
        />
        {/* add attachment here */}
        <div>
          <Link to={`/community/${id}/discussion`}>
            <button id="cancel__button">Cancel</button>
          </Link>
          <button id="update__button" type="submit">Update</button>
        </div>
      </form>
    </div>
  );
}

export default CommunityPostUpdate;
